module.exports = __webpack_public_path__ + "static/media/google_play.74b7d11f.svg";